/** Side-effect-free global/storage keys shared by cmp.js and cmp-console.js. */
export const DEBUG_GLOBAL = "__adcmpDebug";
export const CONSOLE_FLAG = "adcmp_console";
export const CONSOLE_GLOBAL = "__adcmpConsole";
